import React, { useState } from 'react';
import about1 from '../../assets/favdoctor-about-1.png';
import about2 from '../../assets/favdoctor-about-2.jpg';
import about3 from '../../assets/favdoctor-about-3.jpg';
import about4 from '../../assets/favdoctor-about-4.png';
import about5 from '../../assets/favdoctor-about-5.jpg';
import about9 from '../../assets/favdoctor-about-9.png';
import './Body.css';

export default function AboutBody() {
    const [readMore, setReadMore] = useState(false)
    return <div className='AboutBody'>
        <div className='AboutBody__container'>
            <div className='AboutBody__Row'>
                <div className='AboutBody__col-6'>
                    <div className='AboutBody__Image'>
        {/*<img src={about3} alt="FavDoctor-About-1" />*/}
                        <img src={about9} alt="FavDoctor-About-2" />
                        <img src={about2} alt="FavDoctor-About-5" className='AboutBody__Image__Flex' />
                    </div>
                </div>
                <div className='AboutBody__col-6 AboutBody__col-6__Text'>
                    <div className='AboutBody__Title'>
                        <p style={{textAlign: "left", width: 300 + "px"}}>We are The
                            FavDoctor Team</p>
                    </div>
                    <div className='AboutBody__Body'>
                        <p>FavouriteDoctor strives to facilitate seamless connections between users and healthcare providers, empowering them to engage in effective remote collaboration. </p>
                        <p><br/>
                        Our comprehensive platform enables users to effortlessly locate skilled doctors, book appointments, order tests, and access medical reports. These robust features are readily available on both our web and mobile platforms, ensuring convenience and accessibility.
                        </p><br/>
                        <p>
                        We provide immediate feedback and foster collaboration for the efficient delivery of healthcare services. Users can seamlessly connect with healthcare experts remotely, ensuring timely and expert guidance.</p><br/>
                        <p>
                        With our cloud-based solution, patients gain convenient access to their medical information whenever and wherever they need it. By securely storing and managing their health records, we empower individuals to take control of their overall health and well-being. Say goodbye to fragmented information and hello to a holistic approach to healthcare.
                        </p>
                    </div>
                </div>
            </div>
          {/*  {(readMore === false) ? 
                <button onClick={() => { setReadMore(true) }}>Continue Reading</button>
                :
                ''
            }

            <div className={(readMore === true) ? 'AboutBody__Row__Two AboutBody__Row__Two__display' : 'notDisplay'}>
                <div className='AboutBody__col-6__Text'>

                    <div className='AboutBody__Body'>
                        <p>With our platforms we enable immediate feedback and collaboration for the efficient and effective delivery of Healthcare services making use of VoIP technology to connect the user to healthcare expert remotely. Favourite Doctor also provides an integrated payments solution which enables users to make payments directly from their bank account or credit card without stress.</p><br/>

                        <p>  Our cloud-based solution gives patients access to their medical information when and where they need it, improving their overall health and well-being. We help our Users build stronger relationships with their Doctors. The result is happier and healthier people.

                        </p>
                    </div>
                </div>
                <div className='AboutBody__col-6__Two'>
                    <div className='AboutBody__Image__Center__Single'>
                        <img src={about4} alt="Favourite Doctor About-4" />
                        <div className='AboutBody__Image__Center__Double'>
                            <img src={about1} alt="FavDoctor-About-3" />
                            <img src={about1} alt="FavDoctor-About-3" />
                        </div>
                    </div>
                </div>
        </div>
            <div className='AboutBody__Row__Two'>
                <div className='AboutBody__col-6__Text'>

                    <div className='AboutBody__Body'>
                        <p>With our platforms we enable immediate feedback and collaboration for the efficient and effective delivery of Healthcare services making use of VoIP technology to connect the user to healthcare expert remotely. Favourite Doctor also provides an integrated payments solution which enables users to make payments directly from their bank account or credit card without stress.</p><br/>

                        <p>  Our cloud-based solution gives patients access to their medical information when and where they need it, improving their overall health and well-being. We help our Users build stronger relationships with their Doctors. The result is happier and healthier people.

                        </p>
                    </div>
                </div>
                <div className='AboutBody__col-6__Two'>
                    <div className='AboutBody__Image__Center__Single'>
                        <img src={about4} alt="Favourite Doctor About-4" />
                        <div className='AboutBody__Image__Center__Double'>
                            <img src={about1} alt="FavDoctor-About-1" />
                            <img src={about1} alt="FavDoctor-About-1" />
                        </div>
                    </div>
                </div>
            </div>
            {(readMore === false) ? 
                ''
                :
                <button onClick={() => { setReadMore(false) }}>Read Less</button>
            } */}
            <div className='AboutBody__Row__Three'>
                <div className='AboutBody__col-6__Three'>
                    <div className='AboutBody__Image__Three'>
                        <img src={about2} alt="FavDoctor-About-2" />
                    </div>
                </div>
                <div className='AboutBody__col-6__Three'>
                    <div className='AboutBody__Title'>
                        <p>Our Mission</p>
                    </div>
                    <div className='AboutBody__Body'>
                        <p>At our core, we are driven by a mission to effortlessly connect our users to nearby healthcare services, eliminating the stress associated with accessing quality care.  
                        Simultaneously, we empower healthcare providers with real-time access to their clients' medical information, fostering enhanced collaboration and personalized care.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
}